import { render, staticRenderFns } from "./DistributionActivityList.vue?vue&type=template&id=cc6ee4d6&scoped=true&lang=pug&"
import script from "./DistributionActivityList.vue?vue&type=script&lang=ts&"
export * from "./DistributionActivityList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6ee4d6",
  null
  
)

export default component.exports